import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminMessages.css";

function AdminMessages() {
  const navigate = useNavigate();

  return (
    <div className="main-layout">

      <div className="sidebar">
        <h2 className="logo">🏠 RealEstate</h2>

        <ul>
          <li onClick={() => navigate("/admin/dashboard")}>Dashboard</li>
          <li onClick={() => navigate("/admin/properties")}>Properties</li>
          <li onClick={() => navigate("/admin/buys")}>Buys</li>
          <li onClick={() => navigate("/admin/sales")}>Sales</li>
          <li onClick={() => navigate("/admin/rents")}>Rents</li>
          <li className="active">Messages</li>
          <li onClick={() => navigate("/admin/settings")}>Settings</li>
        </ul>
      </div>

      <div className="dashboard-container">
        <div className="topbar">💬 Messages</div>

        <h2>No messages</h2>
      </div>

    </div>
  );
}

export default AdminMessages;